import { useContext } from 'react'

import { Form } from 'components/Form'
import AdUnitsTable from 'features/inventory/ad-unit/components/AdUnitsTable'
import { AdUnitListContext } from 'features/inventory/ad-unit/contexts/AdUnitListContext'
import { useSaveAdUnitProducts } from './hooks/useSaveAdUnitProducts'
import { adUnitTableSchema, AdUnitTableSchema, adUnitTableSchemaDefault } from './schema'

export const AdUnitTableForm = (): React.JSX.Element => {
  const { formId, setTouched, setValid } = useContext(AdUnitListContext)
  const { loading, update } = useSaveAdUnitProducts()

  return (
    <Form<AdUnitTableSchema>
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={adUnitTableSchema}
      schemaDefaults={adUnitTableSchemaDefault}
    >
      {() => <AdUnitsTable />}
    </Form>
  )
}
